<template>
  <v-footer
    :padless="false"
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          cols="6"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                class="mx-2 grey--text text--darken-3"
                v-on="on"
                @click="isDark = isDark === 'dark' ? 'light' : 'dark'"
              >
                <i
                  v-if="isDark === 'dark'"
                  class="fad fa-sun fa-2x grey--text"
                />
                <i
                  v-if="isDark !== 'dark'"
                  class="fad fa-moon fa-2x"
                />
              </a>
            </template>
            <span>Dark/Light Mode</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                class="mx-2 grey--text text--darken-3"
                v-on="on"
                @click="isRtl = isRtl === 'rtl' ? 'ltr' : 'rtl'"
              >
                <i
                  v-if="isDark === 'dark'"
                  class="fad fa-language fa-2x grey--text"
                />
                <i
                  v-if="isDark !== 'dark'"
                  class="fad fa-language fa-2x"
                />
              </a>
            </template>
            <span>En/Fa Language</span>
          </v-tooltip>
        </v-col>

        <v-spacer class="hidden-sm-and-down" />

        <v-col
          cols="6"
        >
          <div
            class="text-left en-text"
            dir="ltr"
          >
            &copy; 2020,
            <a
              href="https://www.garnetcms.ir"
              target="_blank"
            >
              GarnetCMS
              <i class="far fa-gem mx-1 red--text" />
            </a>.
            v4.0.2
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      isDark: 'dark',
      isRtl: 'rtl',
      links: [
        {
          href: '#',
          text: 'Creative Tim',
        },
        {
          href: '#',
          text: 'About Us',
        },
        {
          href: '#',
          text: 'Blog',
        },
        {
          href: '#',
          text: 'Licenses',
        },
      ],
    }),
    watch: {
      isDark (newValue) {
        localStorage.isDark = newValue
        this.$vuetify.theme.dark = newValue === 'dark'
      },
      isRtl (newValue) {
        localStorage.isRtl = newValue
        this.$vuetify.rtl = newValue === 'rtl'
        this.$i18n.locale = newValue === 'rtl' ? 'fa' : 'en'
      },
    },
    mounted () {
      if (localStorage.isDark) {
        this.isDark = localStorage.isDark
      }
      if (localStorage.isRtl) {
        this.isRtl = localStorage.isRtl
      }
    },
  }
</script>
